import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  height: 80%;
  //width: calc(100% - 40px);
  width: 1240px;
  margin: 0 auto;
  background-color: #0F1D2D;
  border: 1px solid rgba(50,65,86,0.40);
  box-shadow: 0 12px 24px 0 #0F1927;
  border-radius: 4px;
`;

export default Container;
